<template>
  <div class="status-page">
    <seats :invitations="invitations" :firstname="user.firstname"></seats>
    <div id="status-content" class="container">
      <div class="row">
        <div class="col text-center font-default">
          <div class="block p-t">
            <h2 class="fnt font-deco">
              {{ $t("STATUS__TITLE").replace("%name%", user.firstname) }}
            </h2>
            <p
              v-html="$t('STATUS__INTRO').replace('%destination%', destination)"
            ></p>
            <p v-html="$t('STATUS__INTRO_2')"></p>
          </div>
        </div>
      </div>

      <div class="block p-t content-md">
        <plane-progress :step="5 - emptyInvitations.length"></plane-progress>
        <slide-x-left-transition :group="true">
          <div
            v-for="(invitation, index) in invitations"
            v-show="
              invitation.createdAt ||
                (emptyInvitations[0] &&
                  emptyInvitations[0].id === invitation.id)
            "
            :key="invitation.id"
          >
            <invitation-form
              :invitation-data="invitation"
              :idx="index"
              @invitationSent="onInvitationSent"
            ></invitation-form>
          </div>
        </slide-x-left-transition>
      </div>

      <!--      <div class="row">
        <div class="col font-default">
          <div class="block p-t">
            <p
              class="footnote fnt font-footnote"
              v-html="$t('STATUS__FOOTNOTE')"
            ></p>
            <p class="footnote fnt font-footnote">
              <sup>**</sup>&nbsp;{{ $t("STATUS__NOT_AF_PLANE") }}
            </p>
          </div>
        </div>
      </div>-->
    </div>
    <section-share :user="user"></section-share>
  </div>
</template>

<script>
import $ from "jquery"
import to from "await-to-js"
import { createNamespacedHelpers } from "vuex"
import { SlideXLeftTransition } from "vue2-transitions"
import SmoothScroll from "smooth-scroll/dist/smooth-scroll.polyfills.min.js"

import InvitationForm from "../components/Form/InvitationForm"
import { mapInvitation } from "../mapper/invitation"
import randomId from "../helpers/randomId"
import Seats from "../components/Lib/SeatsV2"
import UserService from "../services/api/UserService"
import SectionShare from "../components/Layout/SectionShare"
import PlaneProgress from "../components/Lib/Progress"

const userService = new UserService()
const { mapMutations } = createNamespacedHelpers("app")
const scroll = new SmoothScroll()

export default {
  name: "Status",
  components: {
    SlideXLeftTransition,
    InvitationForm,
    Seats,
    SectionShare,
    PlaneProgress
  },
  data() {
    return {
      userId: null,
      token: null,
      maxInvitations: 5,
      user: {},
      invitations: []
    }
  },
  computed: {
    destination() {
      if (!this.user.destination) return null

      const article =
        this.$i18n.locale === "fr" && this.user.destination.article
          ? this.user.destination.article.includes("'")
            ? this.user.destination.article
            : this.user.destination.article + " "
          : ""

      return this.$i18n.locale === "fr"
        ? article + this.user.destination.titleFr
        : this.user.destination.titleEn
    },
    emptyInvitations() {
      return this.invitations.filter(invitation => !invitation.createdAt)
    }
  },
  methods: {
    ...mapMutations(["setSentInvitations"]),
    async refresh() {
      let err, user
      ;[err, user] = await to(userService.get(this.userId, this.token))

      if (err || !user.firstname) {
        this.$router.push({ name: "error" })
      }

      this.user = user
      const activeInvitations = user.invitations
        .filter(invitation => !invitation.isExpired)
        .map(mapInvitation)
      this.invitations = activeInvitations

      this.setSentInvitations(
        activeInvitations.reduce((acc, curr) => {
          acc[curr.id] = curr
          return acc
        }, {})
      )

      const left = this.maxInvitations - activeInvitations.length
      for (let i = 0; i < left; i++) {
        const invitation = mapInvitation({ id: randomId() })
        this.invitations.push(invitation)
      }
    },
    onInvitationSent() {
      this.refresh()
    }
  },
  created() {
    this.userId = this.$route.query.u
    this.token = this.$route.query.t
    if (!this.token || !this.userId) {
      this.$router.push({ name: "home" })
    }

    this.refresh()
  },
  mounted() {
    window.setTimeout(() => {
      scroll.animateScroll(document.querySelector("#app"), null, {
        offset: 0,
        speed: 700,
        updateURL: false,
        popstate: false
      })
    }, 200)
    window.setTimeout(() => {
      if ($(window).scrollTop() < 100) {
        scroll.animateScroll(document.querySelector("#status-content"), null, {
          offset: 0,
          speed: 700,
          updateURL: false,
          popstate: false
        })
      }
    }, 5000)
  }
}
</script>

<style scoped></style>
